// extracted by mini-css-extract-plugin
export default {"legend":"style_legend__Uxxze","item":"style_item__seTiv"};